/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Occurrence_CurrentInputs */

const en_us2_profile_editors_pain_occurrence_current = /** @type {(inputs: Profile_Editors_Pain_Occurrence_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hurts now`)
};

const pt_br2_profile_editors_pain_occurrence_current = /** @type {(inputs: Profile_Editors_Pain_Occurrence_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dói agora`)
};

const es_419_profile_editors_pain_occurrence_current = /** @type {(inputs: Profile_Editors_Pain_Occurrence_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duele ahora`)
};

const pt_pt2_profile_editors_pain_occurrence_current = /** @type {(inputs: Profile_Editors_Pain_Occurrence_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dói agora`)
};

const fr_fr2_profile_editors_pain_occurrence_current = /** @type {(inputs: Profile_Editors_Pain_Occurrence_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mal en ce moment`)
};

const de_de2_profile_editors_pain_occurrence_current = /** @type {(inputs: Profile_Editors_Pain_Occurrence_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tut jetzt weh`)
};

const it_it2_profile_editors_pain_occurrence_current = /** @type {(inputs: Profile_Editors_Pain_Occurrence_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fa male adesso`)
};

/**
* | output |
* | --- |
* | "Hurts now" |
*
* @param {Profile_Editors_Pain_Occurrence_CurrentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_occurrence_current = /** @type {((inputs?: Profile_Editors_Pain_Occurrence_CurrentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Occurrence_CurrentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_occurrence_current(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_occurrence_current(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_occurrence_current(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_occurrence_current(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_occurrence_current(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_occurrence_current(inputs)
	return en_us2_profile_editors_pain_occurrence_current(inputs)
});
export { profile_editors_pain_occurrence_current as "profile-editors.pain_occurrence_current" }